/**
 * This is a subclass factory used to create ES6 mixins.
 * See: http://justinfagnani.com/2015/12/21/real-mixins-with-javascript-classes/
 *
 * See Sample Mixin: rvc/mixins/sample
 *
 * Usage:
 *
 * class MyClass extends mix(Backbone.View).with(MyMixin) {
 *    // your implementation will now have access to the MyMixin's methods
 * }
 *
 */

const mix = (superclass) => new MixinBuilder(superclass);

class MixinBuilder {
  constructor(superclass) {
    this.superclass = superclass;
  }

  with(...mixins) {
    return mixins.reduce((c, mixin) => mixin(c), this.superclass);
  }
}

export { mix as default };
